export const initialFormValues = {
  accountDescription: '',
  accountCode: '',
  additionalExpensesValue: '',
  observations: ''
}
